import ReactGA from 'react-ga4';

export const initGA = (trackingID: string) => {
    ReactGA.initialize(trackingID, {
        // testMode: true,
        gtagUrl: 'https://www.googletagmanager.com/gtm.js',
    });
};

export const PageView = (url: string) => {
    ReactGA.send({ hitType: 'pageview', page: url });
};

export const GAEvent = (category: string, action: string) => {
    ReactGA.event({
        category: category,
        action: action,
        label: `${category} - ${action}`,
    });
};
